<template>
  <div>
    <breadcrumbs home="Recurring transactions">
      <template v-slot:left v-if="reminders">
        <list-notification v-model="showStatus">
          <v-list-item>
            <v-icon>mdi-arrow-right-thin</v-icon>
            {{reminders}} recurring transaction{{reminders===1?' is':'s are'}}  due
            <v-spacer/>
            <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.from=null;filters.to=null;filters.targetType=null;filters.scheduleType='Reminder';filters.name='';filters.reminders='1'})">View</v-btn>
          </v-list-item>
        </list-notification>
      </template>
    </breadcrumbs>

    <purtrak-table name="recurringTransactions" objectType="recurring transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select
                   listEndPoint="recurringTransactions" v-model="selected"
                   fields="id,targetId,targetType,name,scheduleType,advanceDays,scheduleInterval,frequency,dayOfWeek,ordinal,day,month,nextDate,lastDate,toName,amount,reminderDate"
                   :listFilters="listFilters"
                   @dblclick="transaction => create(transaction)"
                   :item-class="transaction => (transaction.reminderDate <= today ? 'warning--text' : (!transaction.nextDate && transaction.scheduleType !== 'Unscheduled' ? 'grey--text' : ''))"
                   title="Recurring transactions"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[]}">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.from=null;filters.to=null;filters.targetType=null;filters.scheduleType=null;filters.name='';filters.reminders='0'">
          <v-list-item>
            <filter-search label="Name" v-model="filters.name"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Target" dense outlined :items="targetTypes" v-model="filters.targetType"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Schedule type" dense outlined :items="scheduleTypes" v-model="filters.scheduleType"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.reminders==='1'" close small class="ml-1" @click:close="filters.reminders='0'">Due</v-chip>
          <v-chip v-show="filters.name" close small class="ml-1" @click:close="filters.name=''">Name: {{filters.name}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.targetType" close small class="ml-1" @click:close="filters.targetType=null">Target: {{targetTypes.find(type => type.value === filters.targetType).text}}</v-chip>
          <v-chip v-show="filters.scheduleType" close small class="ml-1" @click:close="filters.scheduleType=null">Type: {{scheduleTypes.find(type => type.value === filters.scheduleType).text}}</v-chip>
        </template>
      </template>
      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.nextDate="{value}">
        {{value | formatDate}}
      </template>
      <template v-slot:item.targetType="{value}">
        {{targetTypes.find(type => type.value === value).text}}
      </template>
      <template v-slot:item.amount="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.description="{item}">
        {{description(item)}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-menu offset-y>
          <template v-slot:activator="{on}">
            <v-btn fab color="primary" small v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'PurchasingPurchaseOrdersEditNew',params:{onlyRecurring:true}}"><v-list-item-title>Purchase order template</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'PurchasingInventoryReceiptsEditNew',params:{onlyRecurring:true}}"><v-list-item-title>Inventory receipt template</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item :to="{name:'SalesSalesOrdersEditNew',params:{onlyRecurring:true}}"><v-list-item-title>Sales order template</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'SalesShipmentsEditNew',params:{onlyRecurring:true}}"><v-list-item-title>Shipment template</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'SalesInvoicesEditNew',params:{onlyRecurring:true}}"><v-list-item-title>Invoice template</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small >mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="create(item)"><v-list-item-title>Create now</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <v-list-item @click="edit(item)"><v-list-item-title>Edit</v-list-item-title></v-list-item>
            <v-list-item @click="transaction=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected transactions':'this transaction'" @delete="performDelete(transaction.targetId, 'targetId')"/>
    <component :is="dialog" v-bind="dialogProperties" @done="dialog = null"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import {format} from 'date-fns'

export default {
  name: 'RecurringTransactions',
  mixins: [performDelete],
  data() {
    return {
      reminders: 0,
      filters: {
        name: '',
        from: null,
        to: null,
        targetType: null,
        scheduleType: null,
        reminders: '0'
      },
      today: format(new Date(), 'yyyy-MM-dd'),
      showStatus: false,
      dateDisplay: '',
      transaction: {},
      targetTypes: [{text:'All',value:null},{divider:true},{text:'Purchase order',value:'PO'},{text:'Inventory receipt',value:'Receipt'},{divider:true},{text:'Sales order',value:'SalesOrder'},{text:'Shipment',value:'Shipment'},{text:'Invoice',value:'Invoice'}],
      scheduleTypes: [{text:'All',value:null},{divider:true},{text:'Scheduled',value:'Scheduled'},{text:'Reminder',value:'Reminder'},{text:'Unscheduled',value:'Unscheduled'}],
      showDelete: false,
      deleteMultiple: false,
			dialog: null,
      dialogProperties: {},
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'targetType', visible:true},
                       { value: 'scheduleType', visible:true},
                       { value: 'toName', visible:true},
                       { value: 'nextDate', visible:true},
                       { value: 'amount', visible:false},
                       { value: 'description', visible:false},
                       { value: 'lastDate', visible:false},
                       ],
      headers: [{ text: 'NAME', value: 'name', width:'20%',sortable:true},
                { text: 'NEXT', value: 'nextDate', width:'15%',sortable:true},
                { text: 'LAST', value: 'lastDate', width:'15%',sortable:true},
                { text: 'TARGET', value: 'targetType', width:'15%',sortable:false},
                { text: 'CUSTOMER/SUPPLIER', value: 'toName', width:'20%',sortable:false},
                { text: 'AMOUNT', value: 'amount', width:'10%',align:'right',sortable:false},
                { text: 'TYPE', value: 'scheduleType', width:'10%',sortable:false},
                { text: 'DESCRIPTION', value: 'description', width:'30%',sortable:false}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.name)
        filters.push({field:'name', comparator:'contains', value:this.filters.name});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.targetType)
        filters.push({field:'targetType', comparator:'eq', value:this.filters.targetType});
      if (this.filters.scheduleType)
        filters.push({field:'scheduleType', comparator:'eq', value:this.filters.scheduleType});
      if (this.filters.reminders === '1')
        filters.push({field:'reminderDate', comparator:'le', value:this.today});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');

    await this.getStatus();
    this.loading = false;
    if (!['PurchasingPurchaseOrdersEdit','PurchasingPurchaseOrdersEditNew',
          'PurchasingInventoryReceiptsEdit','PurchasingInventoryReceiptsEditNew',
          'SalesSalesOrdersEdit','SalesSalesOrdersEditNew',
          'SalesShipmentsEdit','SalesShipmentsEditNew',
          'SalesInvoicesEdit','SalesInvoicesEditNew'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        this.reminders && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    description(transaction) {
      if (transaction.scheduleType === 'Unscheduled')
        return;
      switch (transaction.scheduleInterval) {
        case 'Daily':
          return `Daily every ${transaction.frequency} day(s)`;
        case 'Weekly':
          return `Weekly every ${transaction.frequency} week(s) on ${transaction.dayOfWeek}`;
        case 'Monthly':
          return `Monthly on ${transaction.ordinal === 'day' ? `${this.dayName(transaction.day)}` : `${transaction.ordinal} ${transaction.dayOfWeek}`} of every ${transaction.frequency} month(s)`;
        case 'Yearly':
          return `Yearly every ${transaction.month} on the ${this.dayName(transaction.day)}`;
      }
    },
    dayName(day) {
      return day < 4 ? ['last day','1st','2nd','3rd'][day] : `${day}th`;
    },
    async getStatus() {
      const results = await this.$apiCall(`query RecurringTransactions {
                                             recurringTransactionsReminders
                                          }`);
      if (!results.error)
        this.reminders = results.data.recurringTransactionsReminders;
    },
    create(transaction) {
      if (transaction.targetType === 'PO')
        this.$router.push({name:'PurchasingPurchaseOrdersEditNew', params:{copyPOId:transaction.targetId, date:transaction.nextDate,
                                                                           fromRecurringTransactionId:transaction.scheduleType==='Reminder' ? transaction.id : null}})
      else if (transaction.targetType === 'Receipt')
        this.$router.push({name:'PurchasingInventoryReceiptsEditNew', params:{copyId:transaction.targetId, date:transaction.nextDate,
                                                                              fromRecurringTransactionId:transaction.scheduleType==='Reminder' ? transaction.id : null}})
      else if (transaction.targetType === 'SalesOrder')
        this.$router.push({name:'SalesSalesOrdersEditNew', params:{copySalesOrderId:transaction.targetId, date:transaction.nextDate,
                                                                  fromRecurringTransactionId:transaction.scheduleType==='Reminder' ? transaction.id : null}})
      else if (transaction.targetType === 'Shipment')
        this.$router.push({name:'SalesShipmentsEditNew', params:{copyShipmentId:transaction.targetId, date:transaction.nextDate,
                                                                  fromRecurringTransactionId:transaction.scheduleType==='Reminder' ? transaction.id : null}})
      else if (transaction.targetType === 'Invoice')
        this.$router.push({name:'SalesInvoicesEditNew', params:{copyInvoiceId:transaction.targetId, date:transaction.nextDate,
                                                                  fromRecurringTransactionId:transaction.scheduleType==='Reminder' ? transaction.id : null}})
    },
    edit(transaction) {
      if (transaction.targetType === 'PO')
        this.$router.push({name:'PurchasingPurchaseOrdersEdit', params:{poId:transaction.targetId}})
      else if (transaction.targetType === 'Receipt')
        this.$router.push({name:'PurchasingInventoryReceiptsEdit', params:{inventoryReceiptId:transaction.targetId}})
      else if (transaction.targetType === 'SalesOrder')
        this.$router.push({name:'SalesSalesOrdersEdit', params:{salesOrderId:transaction.targetId}})
      else if (transaction.targetType === 'Shipment')
        this.$router.push({name:'SalesShipmentsEdit', params:{shipmentId:transaction.targetId}})
      else if (transaction.targetType === 'Invoice')
        this.$router.push({name:'SalesInvoicesEdit', params:{invoiceId:transaction.targetId}})
    }
  }
}
</script>